import './index.css';

import ReactDOM from 'react-dom';
import Root from './Root';
import { installScrollbarAutoHide } from './utilities/scrollbar-activity';

installScrollbarAutoHide();

ReactDOM.render(<Root />, document.getElementById('root'));
